import React from 'react';
import PropTypes from 'prop-types';
import config from 'Config';

import { FormBlock, withForm } from 'Src/shared/form-provider';
import Contact from 'Src/shared/contact';
import {
  SimpleText,
  SimpleType,
  PrefectureSelect,
  EmailText,
  DateText,
  RelationshipType,
  TelType,
  TelText,
  PostalcodeText,
  PaymentMethodType,
  PayoffType,
  WatertapText,
  ConfirmationCheck,
  ReservationCodeText
} from 'Src/shared/form-provider/item';
const { PanelBody, Block, Content, Description } = Contact;
const moment = require('moment');
const properties = config.form_properties;

class OperationDate extends FormBlock {
  /* eslint-disable no-magic-numbers */
  latency = 5; // 本日を含め、${latency}日分は選択不可(=${latency}日後から選択可能)
  range = 30; // ${range}日分選択可能(例外として更に${closedOn}の日数が引かれる)
  closedOn = ['12/29', '12/30', '12/31', '01/01', '01/02', '01/03']; // ${closedOn}は休業日のため、範囲内であっても選択不可
  // properties = { date }; // 'operation';
  description = '';
  required = false;
  /* eslint-enable no-magic-numbers */
  constructor (props) {
    super(props);
    const self = this;
    self.state = self.state || {};
    self.fetchExcludeDate = self.fetchExcludeDate.bind(self);
  }
  componentDidMount () {
    const self = this;
    self.fetchExcludeDate();
  }
  checkClosed (date) {
    const self = this;
    return self.closedOn.some((text) => text === moment(date).format('MM/DD') || text === moment(date).format('M/D'));
  }
  getNotBefore () {
    const self = this;
    let date = self.state.notBefore;
    while (self.checkClosed(date)) {
      date = moment(date)
        .add(+1, 'day')
        .toDate();
    }
    return moment(date).format('YYYY年MM月DD日');
  }
  getNotAfter () {
    const self = this;
    let date = self.state.notAfter;
    while (self.checkClosed(date)) {
      date = moment(date)
        .add(-1, 'day')
        .toDate();
    }
    return moment(date).format('YYYY年MM月DD日');
  }
  getRangeText () {
    const self = this;
    return self.fetchExcludeDate().then(() => {
      return `${self.getNotBefore()}〜${self.getNotAfter()}`;
    });
  }
  fetchExcludeDate () {
    const self = this;
    return new Promise((resolve) => {
      const notBefore = moment({ hour: 0 })
        .add(self.latency, 'days')
        .toDate();
      const notAfter = moment({ hour: 0 })
        .add(1, 'day')
        .subtract(1, 'millisecond')
        .add(self.latency + self.range - 1, 'days')
        .toDate();
      const closedOn = [];
      const time = moment(notBefore);
      while (time.isSameOrBefore(notAfter)) {
        if (self.closedOn.some((v) => v === time.format('MM/DD') || v === time.format('M/D'))) {
          closedOn.push(time.toDate());
        }
        time.add(1, 'day');
      }
      resolve({
        notBefore,
        notAfter,
        closedOn
      });
    }).then((responseData) => {
      self.setState(responseData);
    });
  }
  renderDate () {
    const self = this;
    return (
      <DateText
        name={self.properties.date.name}
        label={self.properties.date.label}
        placeholder={self.properties.date.label}
        minDate={self.state.notBefore}
        maxDate={self.state.notAfter}
        excludeDates={self.state.closedOn}
        isClearable={false}
        required={self.isRequired()}
      />
    );
  }
  renderReadonly () {
    const self = this;
    return (
      <PanelBody>
        <Block>
          <Content caption={self.properties.date.label} readonly={true}>
            {self.renderDate()}
          </Content>
        </Block>
      </PanelBody>
    );
  }
  renderInput () {
    const self = this;
    return (
      <PanelBody>
        <Block>
          {self.description && (
            <Content>
              <Description>{self.description}</Description>
            </Content>
          )}
          <Content required>{self.renderDate()}</Content>
          <Content>
            <Description>
              {`年末・年始は、${self.properties.date.label}として選択できません。`}
              <br />
              選択できない日をご希望の場合は、
              <a href="tel:0561370141" className="font-weight-bold text-dark">
                0561-37-0141（使用開始中止受付ダイヤル）
              </a>
              にご連絡ください。
            </Description>
          </Content>
        </Block>
      </PanelBody>
    );
  }
}
class _OpenDate extends OperationDate {
  properties = { date: properties.openDate };
  description = '選択された使用開始日より、水道が利用可能です。ご希望の使用開始日付を選択してください。';
  required = true;
}
class _CloseDate extends OperationDate {
  properties = { date: properties.closeDate };
  description = '選択された使用中止日は、水道が終日利用可能です。ご使用される最終日を選択してください。';
  required = true;
}
class _NextOpenDate extends OperationDate {
  properties = { date: properties.nextOpenDate };
  description = '選択された使用開始日より、水道が利用可能です。ご希望の使用開始日付を選択してください。';
  required = true;
}
export const OpenDate = withForm(_OpenDate);
export const CloseDate = withForm(_CloseDate);
export const NextOpenDate = withForm(_NextOpenDate);

// ご使用者 お名前
class ParsonName extends FormBlock {
  // properties = { kana, name };
  caption = { kana: '', name: '' };
  required = false;
  renderKana () {
    const self = this;
    return (
      <SimpleText
        name={self.properties.kana.name}
        label={self.properties.kana.label}
        placeholder="ご使用者名（フリガナ）"
        maxLength={50}
        required={self.isRequired()}
        validations={['zenkakuKana']}
      />
    );
  }
  renderName () {
    const self = this;
    return (
      <SimpleText
        name={self.properties.name.name}
        label={self.properties.name.label}
        placeholder="ご使用者名（漢字等）"
        maxLength={50}
        required={self.isRequired()}
      />
    );
  }
  renderReadonly () {
    const self = this;
    return (
      <div>
        <Block>
          <Content caption={self.caption.kana}>{self.renderKana()}</Content>
        </Block>
        <Block>
          <Content caption={self.caption.name}>{self.renderName()}</Content>
        </Block>
      </div>
    );
  }
  renderInput () {
    const self = this;
    const { required } = self;
    const kanaAnnotations = [];
    if (required) {
      kanaAnnotations.push({ important: true, bordered: true, text: '必須' });
    }
    kanaAnnotations.push({ important: true, text: 'ご使用者名（フリガナ）' });
    const nameAnnotations = [];
    if (required) {
      nameAnnotations.push({ important: true, bordered: true, text: '必須' });
    }
    nameAnnotations.push({ important: true, text: 'ご使用者名（漢字等）' });
    return (
      <div>
        <Block>
          <Content>
            <Description example>{'スイドウ　タロウ、（カブ）スイドウショウジ　ソウムブ　ヤマダ'}</Description>
          </Content>
          <Content annotations={kanaAnnotations}>{self.renderKana()}</Content>
        </Block>
        <Block>
          <Content>
            <Description example>{'水道　太郎、（株）水道商事　総務部　山田'}</Description>
          </Content>
          <Content annotations={nameAnnotations}>{self.renderName()}</Content>
        </Block>
      </div>
    );
  }
}
class _ApplicantName extends ParsonName {
  properties = { kana: properties.applicantNameKana, name: properties.applicantName };
  // TODO caption確認
  caption = { kana: 'ご使用者名（フリガナ）', name: 'ご使用者名（漢字等）' };
  required = true;
}
class _ShippingCustomerName extends ParsonName {
  properties = { kana: properties.shippingCustomerNameKana, name: properties.shippingCustomerName };
  // TODO caption確認
  caption = { kana: 'ご使用者名（フリガナ）', name: 'ご使用者名（漢字等）' };
  required = true;
}
const ApplicantName = withForm(_ApplicantName);
const ShippingCustomerName = withForm(_ShippingCustomerName);

class Relation extends FormBlock {
  // properties = {
  //   type
  //   name
  //   detail
  // };
  caption = '';
  required = false;
  constructor (props) {
    super(props);
    const self = this;
    self.typeRef = React.createRef();
  }
  isOther () {
    const self = this;
    return self.typeRef.current && self.typeRef.current.isOther();
  }
  renderType () {
    const self = this;
    const required = self.isRequired();
    return (
      <RelationshipType
        wrappedComponentRef={self.typeRef}
        name={self.properties.type.name}
        label={self.properties.type.label}
        required={required}
      />
    );
  }
  renderName () {
    const self = this;
    // required: 本人以外の場合は必ず入力させたいので、isRequierdに関わらず必須
    return (
      <SimpleText
        name={self.properties.name.name}
        label={self.properties.name.label}
        placeholder="本人以外の関係者のお名前"
        maxLength={50}
        required
      />
    );
  }
  renderDetail () {
    const self = this;
    // required: 本人以外の場合は必ず入力させたいので、isRequierdに関わらず必須
    return (
      <SimpleText
        name={self.properties.detail.name}
        label={self.properties.detail.label}
        placeholder="具体的関係"
        maxLength={50}
        required
      />
    );
  }
  renderReadonly () {
    const self = this;
    const isOther = self.isOther();
    return (
      <div>
        <Block>
          <Content caption={self.caption}>
            {self.renderType()}
            {isOther && (
              <div className="mt-3">
                関係：
                <div className="d-inline-block">{self.renderName()}</div>
                <div className="d-inline-block ml-3">{self.renderDetail()}</div>
              </div>
            )}
          </Content>
        </Block>
      </div>
    );
  }
  renderInput () {
    const self = this;
    const isOther = self.isOther();
    const required = self.isRequired();
    return (
      <div>
        <Block>
          <Content required={required} bottom={isOther ? 'line' : 'none'}>
            {self.renderType()}
          </Content>
        </Block>
        {isOther && (
          <div>
            <Block>
              <Content required={required}>{self.renderName()}</Content>
            </Block>
            <Block>
              <Content>{self.renderDetail()}</Content>
            </Block>
          </div>
        )}
      </div>
    );
  }
}
class _AgentRelation extends Relation {
  properties = {
    type:   properties.agentRelationshipType,
    name:   properties.agentName,
    detail: properties.agentRelationshipDetail
  };
  // TODO caption確認
  caption = 'ご使用者（本人以外の関係者）';
  required = true;
}
const AgentRelation = withForm(_AgentRelation);

export class Email extends FormBlock {
  // properties = {
  //   email
  //   emailDouble
  // };
  renderEmail () {
    const self = this;
    return (
      <EmailText
        name={self.properties.email.name}
        label={self.properties.email.label}
        placeholder="メールアドレス"
        maxLength={50}
        required={self.isRequired()}
      />
    );
  }
  renderEmailDouble () {
    const self = this;
    return (
      <EmailText
        name={self.properties.emailDouble.name}
        label={self.properties.emailDouble.label}
        placeholder="メールアドレスの確認"
        maxLength={50}
        required={self.isRequired()}
        validations={[['matchWith', self.properties.email.name]]}
      />
    );
  }
  renderReadonly () {
    const self = this;
    return (
      <div>
        <Block>
          <Content caption={self.properties.email.label}>{self.renderEmail()}</Content>
        </Block>
      </div>
    );
  }
  renderInput () {
    const self = this;
    const required = self.isRequired();
    return (
      <div>
        <Block>
          <Content>
            <Description example>abc-def@hijk.co.jp</Description>
          </Content>
          <Content required={required}>{self.renderEmail()}</Content>
        </Block>
        <Block>
          <Content>
            <Description>確認のためにもう一度入力してください。</Description>
          </Content>
          <Content required={required || Boolean(self.get(self.properties.email.name))}>
            {self.renderEmailDouble()}
          </Content>
          <Content>
            <Description important asterisked>
              予約内容をメールで送信します。
            </Description>
            <Description important asterisked>
              携帯電話でドメイン指定受信等をされている場合は、
            </Description>
            <Description important indented>
              解除または「@suidou-aichichubu.or.jp」を受信できるよう設定をお願いいたします。
            </Description>
            <Description important asterisked>
              携帯電話での受信は、通信料が発生する場合がありますので、ご了承ください。
            </Description>
          </Content>
        </Block>
      </div>
    );
  }
}
class _ApplicantEmail extends Email {
  properties = {
    email:       properties.email,
    emailDouble: properties.emailDouble
  };
  required = true;
}
const ApplicantEmail = withForm(_ApplicantEmail);

class Tel extends FormBlock {
  // properties = {
  //   type
  //   tel
  //   company
  // };
  caption = '';
  companyCaption = '';
  required = false;
  constructor (props) {
    super(props);
    const self = this;
    self.typeRef = React.createRef();
  }
  renderType () {
    const self = this;
    return (
      <TelType
        wrappedComponentRef={self.typeRef}
        name={self.properties.type.name}
        label={self.properties.type.label}
        required={self.isRequired()}
      />
    );
  }
  renderTel () {
    const self = this;
    return <TelText name={self.properties.tel.name} label={self.properties.tel.label} required={self.isRequired()} />;
  }
  renderCompany () {
    const self = this;
    // required: 区分で会社が選択されている場合、会社名は必須とするため、isRequierdにかかわらず必須
    return <SimpleText name={self.properties.company.name} label={self.properties.company.label} required />;
  }
  isCompany () {
    const self = this;
    return self.typeRef.current && self.typeRef.current.isCompany();
  }
  renderReadonly () {
    const self = this;
    const isCompany = self.isCompany();
    return (
      <div>
        <Block>
          <Content caption={self.caption}>
            {self.properties.type && <div className="d-inline-block mr-3">{self.renderType()}</div>}
            <div className="d-inline-block">{self.renderTel()}</div>
          </Content>
        </Block>
        {isCompany && self.properties.company && (
          <Block>
            <Content caption={self.companyCaption}>{self.renderCompany()}</Content>
          </Block>
        )}
      </div>
    );
  }
  renderInput () {
    const self = this;
    const isCompany = self.isCompany();
    const annotations = [];
    const matchedCaption = self.caption.match(/^(.*)電話番号(.*)$/);
    if (matchedCaption) {
      if (matchedCaption[1]) {
        annotations.push({ important: true, text: matchedCaption[1] });
      }
      annotations.push({ important: true, text: '電話番号' });
      if (matchedCaption[2]) {
        annotations.push({ important: true, text: matchedCaption[2] });
      }
    } else {
      annotations.push(self.caption);
    }
    const hasAnnotations = annotations.length >= 1;
    return (
      <div>
        {self.properties.type && (
          <Block>
            <Content important={hasAnnotations} annotations={annotations}>
              <Description>電話番号の区分を選択してください。</Description>
              {self.renderType()}
            </Content>
          </Block>
        )}
        <Block>
          <Content>
            <Description>
              <Description inline>{self.caption || '電話番号'}を入力してください。</Description>
              <Description inline example>
                5555-66-7777 , 090-8888-9999
              </Description>
            </Description>
          </Content>
          <Content required={self.isRequired()}>{self.renderTel()}</Content>
        </Block>
        {isCompany && self.properties.type && (
          <Block>
            <Content>
              <Description>会社の番号を入力された場合、会社名・所属名を入力してください。</Description>
            </Content>
            {/* required: 会社を選択している場合は必ず入れさせたいので、電話番号欄が必須かどうかに関係なく、必須 */}
            <Content required>{self.renderCompany()}</Content>
          </Block>
        )}
      </div>
    );
  }
}
class _ContactTel extends Tel {
  properties = {
    type:    properties.contactTelType,
    tel:     properties.contactTel,
    company: properties.contactTelCompany
  };
  caption = '日中に連絡可能な電話番号';
  // TODO caption確認
  companyCaption = '会社名・所属名';
  required = true;
}
class _OpenTel extends Tel {
  properties = {
    type:    properties.openAddressTelType,
    tel:     properties.openAddressTel,
    company: properties.openAddressTelCompany
  };
  // TODO caption確認
  caption = 'ご使用住所の電話番号';
  companyCaption = '会社名・所属名';
  required = true;
}
class _ShippingTel extends Tel {
  properties = {
    tel: properties.shippingTel
  };
  // TODO caption確認
  caption = '電話番号';
  required = true;
}
class _NextTel extends Tel {
  properties = {
    type:    properties.nextAddressTelType,
    tel:     properties.nextAddressTel,
    company: properties.nextAddressTelCompany
  };
  // TODO caption確認
  caption = '転居先住所の電話番号';
  companyCaption = '会社名・所属名';
  required = true;
}
const ContactTel = withForm(_ContactTel);
const OpenTel = withForm(_OpenTel);
const ShippingTel = withForm(_ShippingTel);
const NextTel = withForm(_NextTel);

class _Customer extends FormBlock {
  render () {
    // const self = this;
    return (
      <div>
        <PanelBody>
          <ApplicantName />
        </PanelBody>
        <PanelBody>
          <AgentRelation />
        </PanelBody>
        <PanelBody>
          <ApplicantEmail />
        </PanelBody>
        <PanelBody>
          <ContactTel />
        </PanelBody>
      </div>
    );
  }
}
export const Customer = withForm(_Customer);

class Address extends FormBlock {
  // properties = {
  //   postalcode
  //   prefecture
  //   city
  //   address
  //   building
  //   roomNo
  // };
  required = false;
  caption = '住所';
  // TODO caption確認
  postalcodeCaption = '郵便番号';
  constructor (props) {
    super(props);
    const self = this;
    self.onCompletePostalcode = self.onCompletePostalcode.bind(self);
  }
  onCompletePostalcode (postalcode) {
    const self = this;
    const { set } = self.props;
    if (typeof YubinBango !== 'undefined' && YubinBango.Core) {
      // eslint-disable-next-line no-new
      new YubinBango.Core(postalcode, (address) => {
        const { extended, locality, region, street } = address;
        set(self.properties.prefecture.name, region || '');
        set(self.properties.city.name, locality || '');
        set(self.properties.address.name, `${street || ''}${extended || ''}`);
      });
    }
  }
  matchExpectedAddress (params = {}) {
    const self = this;
    const { checkPrefecture = true, checkCity = true } = params;
    const expected = self.expected;
    if (!expected) {
      return Promise.resolve();
    }
    const prefecture = self.get(self.properties.prefecture.name);
    const city = self.get(self.properties.city.name);
    if (!prefecture && !city) {
      return Promise.resolve();
    }
    for (let i = 0, l = expected.length; i < l; i++) {
      const expectedAddress = expected[i];
      if (checkPrefecture) {
        if (!new RegExp(`^${expectedAddress.prefecture}$`).test(prefecture)) {
          continue;
        }
      }
      if (checkCity) {
        if (!new RegExp(`^${expectedAddress.city}`).test(city)) {
          continue;
        }
      }
      return Promise.resolve();
    }
    return Promise.reject(`${self.caption}には給水区域内の住所を選択して下さい。`);
  }
  renderPostalcode () {
    const self = this;
    return (
      <PostalcodeText
        name={self.properties.postalcode.name}
        label={self.properties.postalcode.label}
        required={self.isRequired()}
        onComplete={self.onCompletePostalcode}
      />
    );
  }
  renderPrefecture () {
    const self = this;
    return (
      <PrefectureSelect
        className="p-region"
        name={self.properties.prefecture.name}
        label={self.properties.prefecture.label}
        required={self.isRequired()}
        placeholder="都道府県"
        validations={[() => self.matchExpectedAddress.bind(self)({ checkCity: false })]}
      />
    );
  }
  renderCity () {
    const self = this;
    return (
      <SimpleText
        className="p-locality"
        name={self.properties.city.name}
        label={self.properties.city.label}
        required={self.isRequired()}
        placeholder="市区町村"
        validations={[() => self.matchExpectedAddress.bind(self)()]}
      />
    );
  }
  renderAddress () {
    const self = this;
    return (
      <SimpleText
        className="p-street-address p-extended-address"
        name={self.properties.address.name}
        label={self.properties.address.label}
        required={self.isRequired()}
        placeholder="町名番地"
      />
    );
  }
  renderBuilding () {
    const self = this;
    return (
      <SimpleText
        name={self.properties.building.name}
        label={self.properties.building.label}
        placeholder="建物（アパート）名"
      />
    );
  }
  renderRoomNo () {
    const self = this;
    return (
      <SimpleText name={self.properties.roomNo.name} label={self.properties.roomNo.label} placeholder="棟・部屋番号" />
    );
  }
  renderReadonly () {
    const self = this;
    return (
      <div>
        <PanelBody>
          <Block>
            <Content caption={self.postalcodeCaption}>{self.renderPostalcode()}</Content>
          </Block>
        </PanelBody>
        <PanelBody>
          <Block>
            <Content caption={self.caption}>
              <div className="d-inline-block">{self.renderPrefecture()}</div>
              <div className="d-inline-block">{self.renderCity()}</div>
              <div className="d-inline-block">{self.renderAddress()}</div>
              <div className="d-inline-block ml-2">{self.renderBuilding()}</div>
              <div className="d-inline-block">{self.renderRoomNo()}</div>
            </Content>
          </Block>
        </PanelBody>
      </div>
    );
  }
  renderInput () {
    const self = this;
    const required = self.isRequired();
    return (
      <PanelBody className="h-adr">
        <Block>
          <Content>
            <Description example>555-6666</Description>
          </Content>
        </Block>
        <Block>
          <Content required>{self.renderPostalcode()}</Content>
        </Block>
        <Block>
          <Content required={required}>{self.renderPrefecture()}</Content>
        </Block>
        <Block>
          <Content required={required}>{self.renderCity()}</Content>
        </Block>
        <Block>
          <Content required={required} bottom="line">
            {self.renderAddress()}
            <Description important asterisked>
              市区町村名および番地まで必ず入力してください。
            </Description>
          </Content>
        </Block>
        <Block>
          <Content>{self.renderBuilding()}</Content>
        </Block>
        <Block>
          <Content>
            {self.renderRoomNo()}
            <Description important asterisked>
              建物名および棟・部屋番号まで入力してください。
            </Description>
          </Content>
        </Block>
      </PanelBody>
    );
  }
}
const serviceArea = [
  { prefecture: '愛知県', city: '豊明市' },
  { prefecture: '愛知県', city: '日進市' },
  { prefecture: '愛知県', city: 'みよし市' },
  { prefecture: '愛知県', city: '長久手市' },
  { prefecture: '愛知県', city: '愛知郡東郷町' }
];
class _OpenAddress extends Address {
  properties = {
    postalcode: properties.openPostalcode,
    prefecture: properties.openPrefecture,
    city:       properties.openCity,
    address:    properties.openAddress,
    building:   properties.openBuilding,
    roomNo:     properties.openRoomNo
  };
  required = true;
  // TODO caption確認
  caption = 'ご使用の住所（入居先の住所）';
  expected = serviceArea;
}
class _ShippingAddress extends Address {
  properties = {
    postalcode: properties.shippingPostalcode,
    prefecture: properties.shippingPrefecture,
    city:       properties.shippingCity,
    address:    properties.shippingAddress,
    building:   properties.shippingBuilding,
    roomNo:     properties.shippingRoomNo
  };
  required = true;
  caption = '納付書等発送先の住所';
  expected = null; // すべての住所を許容
}
class _NextAddress extends Address {
  properties = {
    postalcode: properties.nextPostalcode,
    prefecture: properties.nextPrefecture,
    city:       properties.nextCity,
    address:    properties.nextAddress,
    building:   properties.nextBuilding,
    roomNo:     properties.nextRoomNo
  };
  // TODO caption確認
  caption = '転居先の住所';
  required = true;
  expected = null; // すべての住所を許容
}
const OpenAddress = withForm(_OpenAddress);
const ShippingAddress = withForm(_ShippingAddress);
const NextAddress = withForm(_NextAddress);

class _OpenInformation extends FormBlock {
  render () {
    // const self = this;
    return (
      <div>
        <OpenAddress />
        <PanelBody>
          <OpenTel />
        </PanelBody>
      </div>
    );
  }
}
class _NextInformation extends FormBlock {
  render () {
    // const self = this;
    return (
      <div>
        <NextAddress />
        <PanelBody>
          <NextTel />
        </PanelBody>
      </div>
    );
  }
}
export const OpenInformation = withForm(_OpenInformation);
export const NextInformation = withForm(_NextInformation);

class _PaymentMethod extends FormBlock {
  static propTypes = {
    skipWatertapInput: PropTypes.bool // 前住所のお客様番号 入力不要
  };
  properties = {
    type:     properties.paymentMethod,
    watertap: properties.prevWatertapCode,
    confirm:  properties.directDebitConfirm
  };
  // TODO caption確認
  caption = { type: '料金支払方法', watertap: '継続の場合、前住所のお客様番号' };
  directDebitConfirmText = '口座振替の継続を希望し、愛知中部水道企業団が私に代わって手続きをすることを承諾します。';
  constructor (props) {
    super(props);
    const self = this;
    self.typeRef = React.createRef();
  }
  renderType () {
    const self = this;
    return (
      <PaymentMethodType
        wrappedComponentRef={self.typeRef}
        name={self.properties.type.name}
        label={self.properties.type.label}
        required
      />
    );
  }
  renderWatertap () {
    const self = this;
    return (
      <WatertapText
        name={self.properties.watertap.name}
        label={self.properties.watertap.label}
        placeholder="お客様番号"
        required
      />
    );
  }
  renderDebitConfirm () {
    const self = this;
    return (
      <ConfirmationCheck name={self.properties.confirm.name} label={self.properties.confirm.label} required>
        {self.directDebitConfirmText}
      </ConfirmationCheck>
    );
  }
  isDirectDebitNew () {
    const self = this;
    return self.typeRef.current && self.typeRef.current.isDirectDebitNew();
  }
  isDirectDebitContinue () {
    const self = this;
    return self.typeRef.current && self.typeRef.current.isDirectDebitContinue();
  }
  renderReadonly () {
    const self = this;
    const isDirectDebitContinue = self.isDirectDebitContinue();
    return (
      <PanelBody>
        <Block>
          <Content caption={self.caption.type}>{self.renderType()}</Content>
          {isDirectDebitContinue && (
            <div>
              {!self.props.skipWatertapInput && (
                <Content caption={self.caption.watertap}>{self.renderWatertap()}</Content>
              )}
              <Content>
                <div className="text-danger font-weight-bold">{self.renderDebitConfirm()}</div>
              </Content>
            </div>
          )}
        </Block>
      </PanelBody>
    );
  }
  renderInput () {
    const self = this;
    const isDirectDebitNew = self.isDirectDebitNew();
    const isDirectDebitContinue = self.isDirectDebitContinue();
    return (
      <PanelBody>
        <Block>
          <Content required>
            <Description>料金の支払方法を選択して下さい。</Description>
            {self.renderType()}
          </Content>
        </Block>
        {isDirectDebitNew && (
          <Block>
            <Content alignItems="top" important annotations={['口座振替／新規申込']}>
              <h4 className="text-lg-center">【新規申込をご希望のお客さま】</h4>
              <p className="text-lg-center">
                <a
                  href="/okyakusama/shiyou-youshiki/ryokin-youshiki"
                  rel="noopener noreferrer"
                  title="水道料金に関する様式"
                  target="_blank"
                >
                  こちらから申込書をダウンロードしてください。
                </a>
              </p>
            </Content>
            <Content />
          </Block>
        )}
        {isDirectDebitContinue && (
          <Block>
            <Content alignItems="top" important annotations={['口座振替／継続申込']}>
              <h4 className="text-lg-center">【継続申込をご希望のお客さま】</h4>
              {!self.props.skipWatertapInput && (
                <div>
                  <p>
                    前住所（給水区域内：豊明市、日進市、みよし市、長久手市、東郷町）で口座振替をご利用されていたお客さまは、新住所（開始場所）でも引続き口座振替をご利用いただけます。
                  </p>
                  <p className="text-lg-center">
                    口座振替の継続をご希望されるお客さまは、
                    <br />
                    <span className="text-danger font-weight-bold">下の２項目（必須）に入力およびチェック</span>
                    をしてください。
                  </p>
                </div>
              )}
              {self.props.skipWatertapInput && (
                <div>
                  <p>
                    現在、口座振替をご利用されているお客さまは、新住所（開始場所）でも引続き口座振替をご利用いただけます。
                    <br />
                    ※ただし、同一口座に限ります。 口座を変更される場合は、新規申込が必要になります。
                  </p>
                  <p className="text-lg-center">
                    口座振替の継続をご希望されるお客さまは、
                    <br />
                    <span className="text-danger font-weight-bold">下欄を確認いただき、チェック</span>をしてください。
                  </p>
                </div>
              )}
            </Content>
            {!self.props.skipWatertapInput && (
              <Content required>
                <Description>前住所のお客様番号を入力してください。例：1234567-2222</Description>
                {self.renderWatertap()}
              </Content>
            )}
            <Content required>{self.renderDebitConfirm()}</Content>
          </Block>
        )}
      </PanelBody>
    );
  }
}
export const PaymentMethod = withForm(_PaymentMethod);

class _Shipment extends FormBlock {
  properties = {
    type: properties.hasShippingAddress
  };
  // TODO caption確認
  caption = '納付書等発送先';
  types = { 0: '入居先と同じ', 1: '別の発送先を登録する' };
  hasShippingAddress () {
    const self = this;
    const { get } = self.props;
    return String(get(self.properties.type.name)) === '1';
  }
  renderType () {
    const self = this;
    return (
      <SimpleType types={self.types} name={self.properties.type.name} label={self.properties.type.label} required />
    );
  }
  renderAddress () {
    // const self = this;
    return <ShippingAddress />;
  }
  renderTel () {
    // const self = this;
    return <ShippingTel />;
  }
  renderName () {
    // const self = this;
    return <ShippingCustomerName />;
  }
  renderReadonly () {
    const self = this;
    return (
      <div>
        <PanelBody>
          <Block>
            <Content caption={self.caption}>{self.renderType()}</Content>
          </Block>
        </PanelBody>
        {self.hasShippingAddress() && (
          <div>
            {self.renderAddress()}
            <PanelBody>{self.renderTel()}</PanelBody>
            <PanelBody>{self.renderName()}</PanelBody>
          </div>
        )}
      </div>
    );
  }
  renderInput () {
    const self = this;
    return (
      <div>
        <PanelBody>
          <Block>
            <Content required>{self.renderType()}</Content>
          </Block>
        </PanelBody>
        {self.hasShippingAddress() && (
          <div>
            {self.renderAddress()}
            <PanelBody>{self.renderTel()}</PanelBody>
            <PanelBody>{self.renderName()}</PanelBody>
          </div>
        )}
      </div>
    );
  }
}
class _OpenShipment extends _Shipment {
  types = { 0: '入居先と同じ', 1: '別の発送先を登録する' };
}
class _CloseShipment extends _Shipment {
  types = { 0: '転居先と同じ', 1: '別の発送先を登録する' };
}
export const OpenShipment = withForm(_OpenShipment);
export const CloseShipment = withForm(_CloseShipment);

class _Watertap extends FormBlock {
  properties = {
    watertap: properties.watertap
  };
  renderWatertap () {
    const self = this;
    return (
      <WatertapText
        name={self.properties.watertap.name}
        label={self.properties.watertap.label}
        placeholder="お客様番号"
        required
      />
    );
  }
  renderReadonly () {
    const self = this;
    return (
      <PanelBody>
        <Block>
          <Content caption={self.properties.watertap.label}>{self.renderWatertap()}</Content>
        </Block>
      </PanelBody>
    );
  }
  renderInput () {
    const self = this;
    return (
      <PanelBody>
        <Block>
          <Content>
            <Description asterisked>
              お客様番号（水栓番号）は、水道ご使用量のお知らせ、および領収書に記載されております。
            </Description>
            <Description example>1234567-2222</Description>
          </Content>
          <Content required>{self.renderWatertap()}</Content>
        </Block>
      </PanelBody>
    );
  }
}
export const Watertap = withForm(_Watertap);

class _Payoff extends FormBlock {
  properties = {
    type: properties.payoffMethod
  };
  constructor (props) {
    super(props);
    const self = this;
    self.typeRef = React.createRef();
  }
  renderType () {
    const self = this;
    return (
      <PayoffType
        wrappedComponentRef={self.typeRef}
        name={self.properties.type.name}
        label={self.properties.type.label}
        required
      />
    );
  }
  renderReadonly () {
    const self = this;
    return (
      <PanelBody>
        <Block>
          <Content caption={self.properties.type.label}>{self.renderType()}</Content>
        </Block>
      </PanelBody>
    );
  }
  renderInput () {
    const self = this;
    return (
      <PanelBody>
        <Block>
          <Content required>
            <Description>料金の精算方法を選択して下さい。</Description>
            {self.renderType()}
            <Description asterisked>現地での現金による精算をご希望の場合は、</Description>
            <Description indented>
              事前に
              <a href="tel:0561370141" className="font-weight-bold text-dark">
                0561-37-0141（使用開始中止受付ダイヤル）
              </a>
              にご連絡をお願いします。
            </Description>
          </Content>
        </Block>
      </PanelBody>
    );
  }
}
export const Payoff = withForm(_Payoff);

class _CertificationInquiry extends FormBlock {
  properties = {
    reservationCode: properties.reservationCode,
    email:           properties.email
  };
  required = true;
  renderEmail () {
    const self = this;
    return (
      <EmailText
        name={self.properties.email.name}
        label={self.properties.email.label}
        placeholder="メールアドレス"
        maxLength={50}
        required={self.isRequired()}
      />
    );
  }
  renderReservationCode () {
    const self = this;
    return (
      <ReservationCodeText
        name={self.properties.reservationCode.name}
        label={self.properties.reservationCode.label}
        required={self.isRequired()}
      />
    );
  }
  renderReadonly () {
    return null;
  }
  renderInput () {
    const self = this;
    const required = self.isRequired();
    return (
      <div>
        <PanelBody>
          <Block>
            <Content>
              <Description example>1234-567890</Description>
            </Content>
            <Content required={required}>{self.renderReservationCode()}</Content>
          </Block>
        </PanelBody>
        <PanelBody>
          <Block>
            <Content>
              <Description example>abc-def@hijk.co.jp</Description>
            </Content>
            <Content required={required}>{self.renderEmail()}</Content>
          </Block>
        </PanelBody>
      </div>
    );
  }
}
export const CertificationInquiry = withForm(_CertificationInquiry);
